const FORMS_OPTIONS = {

    bankTypeOfAccount: [
        {
            "text":"Current",
            "value":"current"
        },
        {
            "text":"Saving",
            "value":"saving"
        },
    ],
    paymentTypeOptions: [
        {
            "text":"Bank transfer",
            "value":"bankTransfer",
            "isAccountHolderNameMandatory":true
        },
        {
            "text":"Cheque",
            "value":"cheque",
            "isAccountHolderNameMandatory":true
        },
        {
            "text":"Boleto",
            "value":"boleto",
            "isAccountHolderNameMandatory":false
        },
        {
            "text":"Direct debit",
            "value":"directDebit",
            "isAccountHolderNameMandatory":false
        },
        {
            "text":"Citidirect payment made by payroll",
            "value":"citiDirectPayment",
            "isAccountHolderNameMandatory":false
        },
        {
            "text":"Citi tax portal",
            "value":"citiTaxPortal",
            "isAccountHolderNameMandatory":false
        },
        {
            "text":"Mizuho",
            "value":"mizuho",
            "isAccountHolderNameMandatory":false
        },
        {
            "text":"Korea tax portal",
            "value":"koreaTaxPortal",
            "isAccountHolderNameMandatory":false
        }
    ],
}

export default FORMS_OPTIONS